import { blogPosts } from "@/data/blogPosts";
import type { BlogPost } from "@/data/blogPosts";
import { BATCH75_POSTS } from "@/lib/batch75Posts";
import { BATCH74_POSTS } from "@/lib/batch74Posts";
import { BATCH73_POSTS } from "@/lib/batch73Posts";
import { BATCH72_POSTS } from "@/lib/batch72Posts";
import { BATCH71_POSTS } from "@/lib/batch71Posts";
import { BATCH70_POSTS } from "@/lib/batch70Posts";
import { BATCH69_POSTS } from "@/lib/batch69Posts";
import { BATCH68_POSTS } from "@/lib/batch68Posts";
import { BATCH67_POSTS } from "@/lib/batch67Posts";
import { BATCH66_POSTS } from "@/lib/batch66Posts";
import { BATCH65_POSTS } from "@/lib/batch65Posts";
import { BATCH64_POSTS } from "@/lib/batch64Posts";
import { BATCH63_POSTS } from "@/lib/batch63Posts";
import { BATCH62_POSTS } from "@/lib/batch62Posts";
import { BATCH61_POSTS } from "@/lib/batch61Posts";
import { BATCH60_POSTS } from "@/lib/batch60Posts";
import { BATCH59_POSTS } from "@/lib/batch59Posts";
import { BATCH58_POSTS } from "@/lib/batch58Posts";
import { BATCH57_POSTS } from "@/lib/batch57Posts";
import { BATCH56_POSTS } from "@/lib/batch56Posts";
import { BATCH55_POSTS } from "@/lib/batch55Posts";
import { BATCH54_POSTS } from "@/lib/batch54Posts";
import { BATCH53_POSTS } from "@/lib/batch53Posts";
import { BATCH52_POSTS } from "@/lib/batch52Posts";
import { BATCH51_POSTS } from "@/lib/batch51Posts";
import { BATCH50_POSTS } from "@/lib/batch50Posts";
import { BATCH32_POSTS } from "@/lib/batch32Posts";
import { BATCH33_POSTS } from "@/lib/batch33Posts";
import { BATCH34_POSTS } from "@/lib/batch34Posts";
import { BATCH35_POSTS } from "@/lib/batch35Posts";
import { BATCH36_POSTS } from "@/lib/batch36Posts";
import { BATCH37_POSTS } from "@/lib/batch37Posts";
import { BATCH38_POSTS } from "@/lib/batch38Posts";
import { BATCH39_POSTS } from "@/lib/batch39Posts";
import { BATCH40_POSTS } from "@/lib/batch40Posts";
import { BATCH41_POSTS } from "@/lib/batch41Posts";
import { BATCH42_POSTS } from "@/lib/batch42Posts";
import { BATCH43_POSTS } from "@/lib/batch43Posts";
import { BATCH44_POSTS } from "@/lib/batch44Posts";
import { BATCH45_POSTS } from "@/lib/batch45Posts";
import { BATCH46_POSTS } from "@/lib/batch46Posts";
import { BATCH47_POSTS } from "@/lib/batch47Posts";
import { BATCH48_POSTS } from "@/lib/batch48Posts";
import { BATCH49_POSTS } from "@/lib/batch49Posts";

/**
 * Augmented blog post list: new article-creation batches (32, 33, ...)
 * prepended to the canonical `blogPosts` array.
 *
 * `src/data/blogPosts.ts` is at capacity and cannot be extended in place, so
 * the new articles live in their own `src/lib/batchNNPosts.ts` modules and are
 * merged here. Every consumer that needs the full post list (blog index,
 * article page, category pages, related-posts sidebar) should import
 * `allBlogPosts` instead of `blogPosts` so the new articles appear in
 * listings, related-links, and date-sorted feeds.
 *
 * `seo.ts` resolves individual posts via its own `deduplicatePosts` call on
 * this same merged list, so slug resolution and schema generation stay in sync.
 */
export const allBlogPosts: BlogPost[] = [
  ...BATCH75_POSTS,
  ...BATCH74_POSTS,
  ...BATCH73_POSTS,
  ...BATCH72_POSTS,
  ...BATCH71_POSTS,
  ...BATCH70_POSTS,
  ...BATCH69_POSTS,
  ...BATCH68_POSTS,
  ...BATCH67_POSTS,
  ...BATCH66_POSTS,
  ...BATCH65_POSTS,
  ...BATCH64_POSTS,
  ...BATCH63_POSTS,
  ...BATCH62_POSTS,
  ...BATCH61_POSTS,
  ...BATCH60_POSTS,
  ...BATCH59_POSTS,
  ...BATCH58_POSTS,
  ...BATCH57_POSTS,
  ...BATCH56_POSTS,
  ...BATCH55_POSTS,
  ...BATCH54_POSTS,
  ...BATCH53_POSTS,
  ...BATCH52_POSTS,
  ...BATCH51_POSTS,
  ...BATCH50_POSTS,
  ...BATCH49_POSTS,
  ...BATCH48_POSTS,
  ...BATCH47_POSTS,
  ...BATCH46_POSTS,
  ...BATCH45_POSTS,
  ...BATCH44_POSTS,
  ...BATCH43_POSTS,
  ...BATCH42_POSTS,
  ...BATCH41_POSTS,
  ...BATCH40_POSTS,
  ...BATCH39_POSTS,
  ...BATCH38_POSTS,
  ...BATCH37_POSTS,
  ...BATCH36_POSTS,
  ...BATCH35_POSTS,
  ...BATCH34_POSTS,
  ...BATCH33_POSTS,
  ...BATCH32_POSTS,
  ...blogPosts,
];
